const SlotUI = require('SlotUI');
const PSState = require('PSState');
const PSEvents = require('PSEvents');
const { MenuElements } = SlotUI;

/**
 * Will black the screen and fade out on on start replay and resume game from replay menu
 * used for YGG games with areEventsReplayEnabled set to `true`
 */
cc.Class({
    extends: cc.Component,

    properties: {
        time: 0.5,
    },

    // LIFE-CYCLE CALLBACKS:

    onLoad () {
        this.node.active = false;
        PSEvents.onEngineInitialized(() => {
            const historyConfig = SlotUI.getMenuElement(MenuElements.History);

            if (!historyConfig.enabled) {
                this.node.destroy();
                return;
            }

            PSEvents.subscribe(PSEvents.START_SCENE_LOAD, this._showOverlay.bind(this), this);
            PSEvents.subscribe(PSEvents.SCENE_LOAD_COMPLETE, this._fadeOut.bind(this), this);
        });

    },

    onDestroy() {
        PSEvents.removeAllListenerByTarget(this);
    },

    _showOverlay() {
        this.node.active = true;
        this.node.opacity = 255;
    },

    _fadeOut() {
        cc.tween(this.node).
            set({ active: true, opacity: 255 }).
            to(this.time, { opacity: 0 }).
            set({ active: false }).
            start();
    },
});
